import * as React from "react";
import { NavLink } from "react-router-dom";
import Octicon, { getIconByName } from '@github/octicons-react'; //https://octicons.github.com/

export class HistoryButtonGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = { to: '' };
    }

    render() {
        return (
            <NavLink to={this.props.to} className='btn btn-outline-primary m-1 gridButtonWidth'>
                <Octicon icon={getIconByName('book')} className='mb-1' ariaLabel='History' /></NavLink>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/HistoryButtonGrid.js